export const SISIntegrations = {
  POWER_SCHOOL: 'powerschool',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/IntegrationsEnum.js